import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'

interface Props {
  contentType: 'article' | 'product update',
  enableModal: boolean,
  onClose: () => void
}

const DraftPublishedModal = (props: Props) => {
  const { contentType, enableModal, onClose } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title="Your draft can't be deleted." onClose={onClose} />
      <ModalBody>
        {`This ${contentType} has already been published, so we could not make changes or delete this draft.`}
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Go back to homepage'
          variant='primary'
          onClick={() => { window.location.assign(window.location.origin + '/moderation/overview') }}
        />
      </ModalFooter>
    </Modal>
  )
}

export default DraftPublishedModal
